export default __webpack_public_path__ + "static/media/logo.dd41ff8a.jpg";